import { Button } from '@mui/joy';

import ClaimWelcomeGiftIcon from '@/icons/ClaimWelcomeGiftIcon.svg?react';

export const ClaimCreditsModalCard = (props: {
  onNext: () => void;
  isMutating: boolean;
}) => {
  return (
    <div className="mt-3 flex flex-col gap-[44px]">
      <div className="flex flex-col items-center gap-7">
        <div className="max-h-[172px] overflow-visible">
          <ClaimWelcomeGiftIcon />
        </div>
        <div className="flex flex-col items-center gap-3">
          <span>Enjoy $250 of traces on us!</span>
          <span className="text-sm">
            Note: this applies to traces only and lasts one year.
          </span>
        </div>
      </div>
      <div className="self-end">
        <Button
          onClick={props.onNext}
          color="primary"
          variant="solid"
          loading={props.isMutating}
        >
          Claim free credit
        </Button>
      </div>
    </div>
  );
};
